import AppButton from '../../../components/AppButton'
import './HomeClient.scss'
import * as React from 'react'
import { AppointmentData, ClientRequestType, ProfessionalData } from "../../../models"
import { AppointmentEntity } from "../../../store/entities/state"
import { useTranslations } from "../../../store/translations/hooks"
import Typography from '../../../components/Typography'
import { isPaid } from '../../../shared/models-helpers/appointmentDataHelper'
import { getNowDateString } from '../../../shared/utils'
import { formatEuros } from '../../../shared/string'
import { TK } from '../../../store/translations/translationKeys'
import { serviceName } from '../../../shared/appointmint/appointment'
import { useGeneralSettings } from '../../../store/settings/hooks'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { useState } from 'react'

const todayDate = getNowDateString()

const appointmentColor = (a: AppointmentEntity) => isPaid(a) ? '#62b39b'
    : a.date < todayDate ? '#d15656'
    : '#49b2e5'

interface AppointmentsListProps {
    appointments: AppointmentEntity[]
    professionals: Record<string, ProfessionalData>
    onCancel?: (appointment: AppointmentEntity) => void
}

export const AppointmentsList: React.FC<AppointmentsListProps> = ({appointments, professionals, onCancel}) => {
    const t = useTranslations()
    const generalSettings = useGeneralSettings()
    const [cancelling, setCancelling] = useState<AppointmentData|undefined>(undefined)

    return (
        <div className='appointments-list'>
            {appointments.sort((a, b) => a.date <= b.date ? 1 : -1).map(a => (
                <div key={a.id} className='appointment-panel'>
                    <div style={{background: appointmentColor(a)}}>
                        <div className='appointment-left'>
                            <Typography size='larger'>{serviceName(a.type, generalSettings)}</Typography>
                            <Typography size='small'>{a.professionalName}</Typography>
                            <Typography size='small'>{a.room}</Typography>
                        </div>
                        <div className='appointment-rigth'>
                            <Typography size='small'>{a.date}</Typography>
                            <Typography size='small'>{a.start}-{a.end}</Typography>
                            { a.date < todayDate || isPaid(a)
                                ? <Typography size='large' className='appointment-price'>({t(isPaid(a) ? TK.paid : TK.notPaid)}) {formatEuros(a.price)}</Typography>
                                : <Typography size='large' className='appointment-price'>{formatEuros(a.price)}</Typography>
                            }
                        </div>
                    </div>
                    {
                        a.clientRequest === ClientRequestType.Cancel ? <div style={{textAlign: 'end'}}>🙅‍♂️ {t(TK.cancelRequestedByTheClient)}</div>
                        : a.clientRequest === ClientRequestType.Reschedule ? <div style={{textAlign: 'end'}}>🙋‍♂️ {t(TK.rescheduleRequestedByTheClient)}</div>
                        : a.date >= todayDate && onCancel ? <div><AppButton outline onClick={() => setCancelling(a)}>{t(TK.cancel)}</AppButton></div>
                        : false
                    }
                </div>
            ))}

            <Modal isOpen={!!cancelling} toggle={() => setCancelling(undefined)}>
                <ModalHeader toggle={() => setCancelling(undefined)}>{t(TK.areYouSure)}</ModalHeader>
                <ModalBody style={{whiteSpace: 'pre-line'}}>{t(TK.clientCancelNote)}</ModalBody>
                <ModalFooter>
                    <AppButton
                        color='success'
                        onClick={() => {setCancelling(undefined); onCancel && cancelling && onCancel(cancelling)}}
                    >
                        {t(TK.cancelAppointment)}
                    </AppButton>
                </ModalFooter>
            </Modal>
        </div>
    )
}
